import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import { Navbar, NavDropdown } from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import Swal from "sweetalert2";

const ServiceRoleMaster = () => {
    const [roleName, setRoleName] = useState('');
    const [roleDescription, setRoleDescription] = useState('');
    const [roles, setRoles] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [currentRoleId, setCurrentRoleId] = useState(null); 
    const [show, setShow] = useState(false);
    const [roleToDelete, setRoleToDelete] = useState(null);
    const [isLogin, setIsLogin] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 25; 
     const [totalItems, setTotalItems] = useState(0);
    const [startIndex, setStartIndex] = useState(0);
    const [ searchQuery,setSearchQuery] = useState('');
    const history = useHistory();

    useEffect(() => {
        fetchRoleData();
    }, [currentPage]);

    const fetchRoleData = async () => {
        const token = localStorage.getItem('token');
        const startIndexCalc = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndexCalc + itemsPerPage;
        setIsLogin(true);
        try {
          const response = await axios.get(`${var_api}/api/role-details/get`, {
            headers: {
              Authorization: `${token}`,
            },
          });
          const rolemaster = response.data;
    
          if (rolemaster.length > 0) {
            setRoles(rolemaster);
            setTotalItems(rolemaster.length); // Total number of items
          } else {
            console.log('No data found.');
            setRoles([]);
            setTotalItems(0);
          }
          setIsLogin(false);
        } catch (error) {
          console.log('Error fetching data:', error);
          if (error.response && error.response.status === 401) {
            history.push('/signin');
          }
          setRoles([]);
          setIsLogin(false);
        }
      };
    

    const capitalizeEachWord = (str) => {
        return str.toLowerCase().replace(/(^|\s)\S/g, function (match) {
          return match.toUpperCase();
        });
      };

    const roleMasterpost = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        setIsLogin(true);
        const camelCaseRoleName = capitalizeEachWord(roleName);
        const payload = {
            role_name: camelCaseRoleName,
            description: roleDescription,
        };

        try {
            let response;
            if (editMode) {
                response = await axios.put(`${var_api}/api/role-master/put/${currentRoleId}`, payload, {
                    headers: {
                        'Authorization': `${token}`
                    }
                });
                setIsLogin(false);
            } else {
                response = await axios.post(`${var_api}/api/role-master/post`, payload, {
                    headers: {
                        'Authorization': `${token}`
                    }
                });
                setIsLogin(false);
            }
            if (response.status === 200) {
                Swal.fire({
                  icon: 'success',
                  text: editMode ? 'Role Updated Successfully' : 'Role Created Successfully',
                  confirmButtonColor: '#007500',
                });
                console.log(editMode ? 'Role updated successfully!' : 'Role created successfully!');
              }
            fetchRoleData();
            resetForm();
        } catch (error) {
            setIsLogin(false);
            console.error('Error:', error);
            if (error.response && error.response.status === 401) {
                history.push('/signin');
            }else{
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: error.response?.data?.error || 'Something went wrong!',
                  confirmButtonColor: '#007500',
                });
              }
        }
    };
    const handleOpenConfirmation = (roleId) => {
        setRoleToDelete(roleId);
        setShow(true);
    };

    const handleCloseConfirmation= ()=>{
        setShow(false)
      };
    const resetForm = () => {
        setRoleName('');
        setRoleDescription('');
        setEditMode(false);
        setCurrentRoleId(null);
    };

    const handleEdit = (role) => {
        setRoleName(role.role_name);
        setRoleDescription(role.description);
        setEditMode(true);
        setCurrentRoleId(role.id);
    };

    const handleDelete = async () => {
        const token = localStorage.getItem('token');
        setIsLogin(true);
        try {
            await axios.delete(`${var_api}/api/role-master/delete/${roleToDelete}`, {
                headers: {
                    'Authorization': `${token}`
                }
            });
            console.log('Role deleted successfully!');
            fetchRoleData();
            handleCloseConfirmation();
            setIsLogin(false);
        } catch (error) {
            console.error('Error deleting role:', error);
            if (error.response && error.response.status === 401) {
                history.push('/signin');
            }
        }
    };
    const handleSearchInput = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1); // Reset to the first page when searching
      };
    
      // Apply search and pagination to the roles array
      const filteredRoles = Array.isArray(roles) && roles.filter((role) => {
        const searchLower = searchQuery.toLowerCase();
        return (
          (role.role_name && role.role_name.toString().toLowerCase().includes(searchLower)) ||
          (role.description && role.description.toString().toLowerCase().includes(searchLower))
        );
      });
    
      // Calculate paginated results after applying search filter
      const paginatedRoles = filteredRoles.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );
    
      // Handle page change
      const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
      };

        //go to home
 const handleGoToHome = () => {
    history.push('/sb-home');
  }

    return (
        <>
         {isLogin && <Loader />}
            <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
                <Navbar.Brand href="#home">
                    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mx-auto">
                        <Nav.Link href="#" style={{ color: "black", fontSize: "25px", letterSpacing: "2px" }}>
                            ROLE MASTER
                        </Nav.Link>
                    </Nav>
                    <Nav className="ms-auto">
                        <Nav.Link onClick={handleGoToHome} style={{ color: "black", fontSize: "15px" }}>
                            <button className="btn" style={{ backgroundColor: "rgb(89, 128, 71)", color: "white" }}>
                                <i className="bi bi-house"></i> Go to home
                            </button>
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            <br />
            <br />
            <br />
            <br />
            <div style={{ margin: "auto", padding: "20px" }}>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                        <Card style={{
                            border: "none", maxWidth: "28rem", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px",
                            boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px"
                        }}>
                            <Card.Body>
                                <h5 style={{ textAlign: "center", color: "rgb(89, 128, 71)", fontWeight: "bold" }}>{editMode ? 'Edit Role' : 'Create Role'}</h5>
                                <Form onSubmit={roleMasterpost}>
                                    <Form.Group controlId="formBasicName" className="mt-3">
                                        <Form.Label>Role Name</Form.Label>
                                        <Form.Control type="text" placeholder="Enter Role Name" value={roleName}
                                            onChange={(e) => setRoleName(e.target.value)} required />
                                    </Form.Group>

                                    <Form.Group controlId="formBasicPhone" className="mt-3">
                                        <Form.Label>Role Description</Form.Label>
                                        <Form.Control type="text" placeholder="Enter Role Description" value={roleDescription}
                                            onChange={(e) => setRoleDescription(e.target.value)} />
                                    </Form.Group>

                                    <Button variant="primary" type="submit" className="mt-3" style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }} >
                                        {editMode ? 'Update' : 'Submit'}
                                    </Button>{" "}
                                    <Button variant="danger" type="button" className="mt-3" onClick={resetForm}>
                                        Reset
                                    </Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{ padding: "0px", margin: "0px" }}>
                        <Card style={{
                            border: "none", maxWidth: "60rem", padding: "20px", margin: "auto", height: "auto", borderRadius: "20px",
                            fontFamily: "Arial, Helvetica, sans-serif"
                        }}>
                            <h5 style={{ color: "rgb(89, 128, 71)", fontWeight: "bold" }}>Role List  <span style={{ float: "right", fontSize: "17px", color: "black", fontWeight: "bold" }}>
                                <Form.Control type="text" placeholder="Search..." onChange={handleSearchInput}/></span> </h5>
                            <div style={{ float: "left" }}>
                            </div>
                            <Table responsive className="mt-3">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Role Name</th>
                                        <th>Role Description</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
          {paginatedRoles.length > 0 ? (
            paginatedRoles.map((role, index) => (
              <tr key={role.id}>
                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td>{role.role_name}</td>
                <td>{role.description}</td>
                <td>
                  <Button
                    variant="primary"
                    className="m-1"
                    onClick={() => handleEdit(role)}
                  >
                    <i className="bi bi-pencil-square"></i>
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" style={{ textAlign: 'center' }}>
                No Data Available
              </td>
            </tr>
          )}
        </tbody>
                            </Table>
                            <Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={filteredRoles.length} // Update total count to reflect filtered data
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
                        </Card>
                    </Col>
                </Row>
                <Modal
        show={show}
        onHide={handleCloseConfirmation}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
          <Modal.Title  style={{fontFamily:"serif",fontWeight:"bolder",marginLeft:"190px"}}>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px",backgroundColor:"white"}}>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure You want to Delete ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={handleCloseConfirmation}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal>
            </div>
        </>
    )
}

export default ServiceRoleMaster;
